import axios from 'axios'
import store from '@/store'
import { getCookie } from '@/library/utils'
import { Message } from 'view-design';
import { setStore } from '@/library/utils'

// import { Spin } from 'iview'
const addErrorLog = errorInfo => {
    const { statusText, status, request: { responseURL } } = errorInfo
    let info = {
        type: 'ajax',
        code: status,
        mes: statusText,
        url: responseURL
    }
    if (!responseURL.includes('save_error_logger')) store.dispatch('addErrorLog', info)
}

class HttpRequest {
    constructor(baseUrl = baseURL) {
        this.baseUrl = baseUrl
        this.queue = {}
    }
    getInsideConfig(options) {
        if (options.method == 'PATCH') {
            const config = {
                // baseURL: this.baseUrl,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': getCookie('token') === false ? '' : 'JWT ' + getCookie('token')
                }
            }
            return config
        }
        const config = {
            // baseURL: this.baseUrl,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': getCookie('token') === false ? '' : 'JWT ' + getCookie('token')
            }
        }
        return config
    }
    destroy(url) {
        delete this.queue[url]
        if (!Object.keys(this.queue).length) {
            // Spin.hide()
        }
    }
    interceptors(instance, url) {
        // 请求拦截 
        instance.interceptors.request.use(config => {
                // 添加全局的loading...
                if (!Object.keys(this.queue).length) {
                    // Spin.show() // 不建议开启，因为界面不友好
                }
                this.queue[url] = true
                return config
            }, error => {
                // return Promise.reject(error)
            })
            // 响应拦截
        instance.interceptors.response.use(res => {
            this.destroy(url)
            const { detail, code, message, count } = res.data
            return { detail, code, message, count }
        }, error => {
            this.destroy(url)
            let errorInfo = error.response
            if (errorInfo.status === 401) {
                setStore('userinfo', '')
                window.location.href = "/login"
            }
            // if (errorInfo.status === 500) {
            //     window.location.href = "/login"
            // }
            if (errorInfo.status === 400) {
                Message['error']({
                    background: true,
                    content: errorInfo.data.non_field_errors || '您提交的内容不存在！'
                });
            }

            if (!errorInfo) {
                const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error))
                errorInfo = {
                    statusText,
                    status,
                    request: { responseURL: config.url }
                }
            }
            addErrorLog(errorInfo)
                // return Promise.reject(error)
        })
    }
    request(options) {
        const instance = axios.create()
        options = Object.assign(this.getInsideConfig(options), options)
        this.interceptors(instance, options.url)
        return instance(options)
    }
}
export default HttpRequest